import { defineComponent as _defineComponent } from 'vue'
import ClipLoader from "vue-spinner/src/ClipLoader.vue"

interface ButtonProps {
  block?: boolean
  disabled?: boolean
  primary?: boolean
  loading?: boolean
  md?: boolean
  type?: "button" | "submit" | "reset"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonComponent',
  props: {
    block: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    primary: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    md: { type: Boolean, default: false },
    type: { default: "button" }
  },
  emits: ["click"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit

const __returned__ = { emit, ClipLoader }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})